import React from 'react'
import { i18nTranslate } from 'src/utils'
import { Container, Button } from 'react-bootstrap'
import {
  IoIosArrowBack as ArrowBackwardIcon,
} from 'react-icons/io'
import { SkuTable } from 'src/views/components'

class ReorderView extends React.Component {
  static defaultProps = {
    title: 'Order History',
  }
  handleBack = () => {
    const { handleBack } = this.props
    handleBack()
  }
  componentDidMount() {
    //Make getOrderId call from reorderview for updated order data
    if (this.props.selectedOrderId !== '') {
      this.props?.handleOrderIdCall?.(this.props?.selectedOrderId)
    }
  }
  render() {
    const { orderList, title, costCenterId } = this.props

    // IOM-433 - Hide returned items from Order History and Reorder
    const orderItems =
      orderList.filter(item => item?.item?.itemInfo?.status != 'Returned') || []

    const BackIcon = ArrowBackwardIcon
    return (
      <Container className="reorder-container bg-white py-2">
        <Button
          variant="link"
          className="d-flex align-items-center text-decoration-none pb-1 return-to-history-button"
          onClick={this.handleBack}
          data-testid="qa-return-to-order-history-title">
          <BackIcon />
          {title}
        </Button>
        <div className="h5 text-center" data-testid="qa-reorder-title">
          {i18nTranslate('reorder.title', 'Reorder')}
        </div>
        <SkuTable
          skuList={orderItems}
          costCenterId={costCenterId}
          isFromOrderHistory={true}
          {...this.props}
        />
      </Container>
    )
  }
}

export default ReorderView
export { ReorderView }
